
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[[...params]]",
      function () {
        return require("private-next-pages/s/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[[...params]]"])
      });
    }
  